import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsProductCustomLinkAPI extends ComponentAPI<any> {

  @AwesomeEvent
  onClickLink = new ClickEventListener();

}
